import { Component, ElementRef, viewChild } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { DialogBackdropDirective } from "../directives/dialog-backdrop/dialog-backdrop.directive";

@Component({
  selector: 'modals',
  imports: [ButtonComponent, DialogBackdropDirective],
  templateUrl: './modals.component.html',
  styleUrl: './modals.component.scss',
})
export class ModalsComponent {
  dom_modal = viewChild<ElementRef>('modal');

  title: string = '';
  message: string = '';
  second_message: string = '';
  positive_text: string = '';
  negative_text: string = '';
  positive_fn!: Function;
  negative_fn!: Function;
  type: 'info' | 'confirm' | 'confirm-warning' = 'info';
  align: 'start' | 'center' | 'end' = 'start';
  locked: boolean = false;
  staticModal: boolean = false;
  loading: boolean = false

  constructor() {}

  public showInfo(
    title: string,
    message: string,
    positiveText: string,
    positiveFn: Function = () => {},
    staticModal = false,
    locked = false,
  ) {
    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.positive_fn = positiveFn;
    this.type = 'info';
    this.staticModal = staticModal;
    this.locked = locked;
    this.onShow();
  }

  public showConfirm(
    title: string,
    message: string,
    positiveText: string,
    negativeText: string,
    positiveFn: Function = () => {},
    negativeFn: Function = () => {},
    staticModal = false,
  ) {
    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.negative_text = negativeText;
    this.positive_fn = positiveFn;
    this.negative_fn = negativeFn;
    this.type = 'confirm';
    this.staticModal = staticModal;
    this.onShow();
  }
  public showConfirmWarning(
    title: string,
    message: string,
    positiveText: string,
    negativeText:string,
    positiveFn: Function = ()=>{},
    negativeFn: Function = ()=>{},
    second_message?: string
  ){

    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.negative_text = negativeText;
    this.positive_fn = positiveFn;
    this.negative_fn = negativeFn;
    this.type = 'confirm-warning';

    if(second_message) {
      this.second_message = second_message;
    }

    // this.staticModal = false;
    this.onShow();
  }

  positiveAction() {
    if (this.positive_fn) {
      this.positive_fn();
    }
    this.onDismiss();
  }

  actionWithCallback() {
    const dismiss = () => {
      this.loading = false
      this.onDismiss();
    };
    this.positive_fn?.(dismiss);
  }

  negativeAction() {
    if (this.negative_fn) {
      this.negative_fn();
    }
    this.onDismiss();
  }

  public textAlign(align: 'start' | 'center' | 'end' = 'start') {
    this.align = align;
    return this;
  }

  onDismiss() {
    this.dom_modal()?.nativeElement.close();
  }

  onShow() {
    this.dom_modal()?.nativeElement.show();
  }

  onLoadState() {
    this.loading = true;
  }

  onLoadEnd() {
    this.loading = true;
  }
}
